import React from 'react';
import classNames from 'classnames';

import { ScheduleOnClick, SuggestedSchedules } from '../types';

type IProps = {
  selectedSchedule: boolean;
  schedule: SuggestedSchedules;
  onClick?: ScheduleOnClick;
  initialSelectionFeedback?: boolean;
};

const Schedule: React.FC<IProps> = ({
  selectedSchedule,
  schedule,
  onClick,
  initialSelectionFeedback = false,
}) => {
  const scheduleClassNames = classNames([
    'schedule-reply-modal--schedule',
    {
      selected: selectedSchedule,
      initial: initialSelectionFeedback,
    },
  ]);
  return (
    <div onClick={() => onClick?.(schedule)} className={scheduleClassNames}>
      <p className="day">{schedule.title}</p>
      <p className="date">{schedule.displayDate}</p>
    </div>
  );
};

export default Schedule;
